import { jsx as _jsx } from "react/jsx-runtime";
// import { FreeButton } from 'components/UserCabinet/FreeButton/FreeButton';
// import { CheckInOut } from '../CheckInOut/CheckInOut';
import s from './OptionButton.module.scss';
import { useTranslation } from 'react-i18next';
export const OptionButton = ({ checkInTime, onOpen }) => {
    const { t } = useTranslation('userCabinet');
    return (_jsx("div", Object.assign({ className: s.container }, { children: _jsx("button", Object.assign({ className: s.button, onClick: onOpen }, { children: t('buttonToBook') })) })));
};
